module.exports = __webpack_public_path__ + "img/unknown.a9affaf.svg";